import { render, staticRenderFns } from "./_resupplyEdit.tab.vue?vue&type=template&id=38aafe7d&scoped=true"
import script from "./_resupplyEdit.tab.vue?vue&type=script&lang=js"
export * from "./_resupplyEdit.tab.vue?vue&type=script&lang=js"
import style0 from "./_resupplyEdit.tab.vue?vue&type=style&index=0&id=38aafe7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aafe7d",
  null
  
)

export default component.exports